import React from "react";
import { ImageOne } from "../assets/images";

const FirstTab = () => {
  const handleDownloadClick = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      window.open(
        "https://play.google.com/store/apps/details?id=com.empfly.pulse",
        "_blank",
      );
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      window.open(
        "https://apps.apple.com/in/app/example-app/id123456789",
        "_blank",
      );
    } else {
      window.open(
        "https://play.google.com/store/apps/details?id=com.empfly.pulse",
        "_blank",
      );
    }
  };

  return (
    <div className="firstTabContainer">
      <div className="firstTabContent">
        <h1 className="firstTabHeading">
          Healing Beyond Medicine, <br /> Every Step of the Way
        </h1>

        <p className="firstTabSub">
          AI + expert-led wellness platform designed for patients battling
          breast cancer.
        </p>

        <div className="firstTabButtons">
          <button
            onClick={() => (window.location.href = "tel:9311440991")}
            className="firstTabBtn"
          >
            Connect with us
          </button>

          <button
            onClick={handleDownloadClick}
            className="firstTabBtn secondaryBtn"
          >
            Download App
          </button>
        </div>
      </div>

      {/* ✅ IMAGE (ABSOLUTE BOTTOM) */}
      <div className="firstTabImage">
        <img src={ImageOne} alt="Breast Cancer Support" />
      </div>

      {/* ✅ HIGHLIGHT OVER IMAGE */}
      <div className="firstTabHighlight">
        We bring together emotional support, nutritional coaching, and physical
        recovery all personalized to your journey.
      </div>

      <style>
        {`
        .firstTabContainer {
          position: relative;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          background-color: #d4f4a3;
          padding: 40px 5vw 120px; /* space for overlap */
          border-radius: 30px;
          overflow: hidden;
        }

        .firstTabContent {
          flex: 1 1 55%;
          min-width: 260px;
          z-index: 2;
        }

        .firstTabHeading {
          font-size: clamp(2.4rem, 3.5vw, 3.6rem);
          color: #2f4d23;
          margin-bottom: 20px;
          font-family: Georgia, serif;
        }

        .firstTabSub {
          font-size: clamp(1.1rem, 1.6vw, 1.5rem);
          color: #3d5c2f;
          font-style: italic;
          margin-bottom: 30px;
        }

        .firstTabButtons {
          display: flex;
          gap: 15px;
          flex-wrap: wrap;
        }

        .firstTabBtn {
          background-color: #2f4d23;
          color: white;
          padding: 12px 20px;
          border-radius: 25px;
          border: none;
          cursor: pointer;
        }

        .secondaryBtn {
          background-color: white;
          color: #2f4d23;
          border: 2px solid #2f4d23;
        }

        /* ✅ IMAGE TOUCHING BOTTOM */
        .firstTabImage {
          position: absolute;
          right: 5vw;
          bottom: 0; /* 👇 touches green box bottom */
          z-index: 2;
        }

        .firstTabImage img {
          height: clamp(300px, 50vh, 480px);
          display: block;
        }

        /* ✅ HIGHLIGHT OVER IMAGE */
        .firstTabHighlight {
          position: absolute;
          left: 50%;
          bottom: 25px;
          transform: translateX(-50%);
          background-color: #f5dcff;
          padding: 16px 32px;
          border-radius: 999px;
          font-size: clamp(0.95rem, 1.4vw, 1.3rem);
          box-shadow: 0 4px 10px rgba(0,0,0,0.1);
          white-space: nowrap;
          max-width: 85%;
          z-index: 5; /* 👆 ABOVE IMAGE */
        }

        /* TABLET */
        @media (max-width: 1200px) {
          .firstTabImage {
            position: relative;
            right: auto;
            bottom: auto;
            margin-top: 20px;
            display: flex;
            justify-content: center;
          }

          .firstTabHighlight {
            position: relative;
            transform: none;
            margin: 20px auto 0;
            white-space: normal;
            text-align: center;
          }
        }

        /* MOBILE */
        @media (max-width: 768px) {
          .firstTabContainer {
            flex-direction: column;
            text-align: center;
            padding: 24px 18px;
          }

          .firstTabImage img {
            width: 70%;
            height: auto;
          }

          .firstTabHighlight {
            position: static;
            transform: none;
            margin-top: 20px;
            white-space: normal;
          }
        }
        `}
      </style>
    </div>
  );
};

export default FirstTab;
